/* KUKO / CATHARSIS — gate countdown, enter-lift, 360 turntable, size pills */
(function () {
  'use strict';

  /* ---------- COUNTDOWN (gate + password landing) ---------- */
  function initCountdowns() {
    var roots = document.querySelectorAll('[data-kk-countdown]');
    roots.forEach(function (root) {
      var target = root.getAttribute('data-target');
      var nums = root.querySelectorAll('[data-kk-cd]');
      if (!target || !nums.length) return;
      var end = new Date(target).getTime();
      if (isNaN(end)) return;
      var pad = function (n, w) { n = String(n); while (n.length < (w || 2)) n = '0' + n; return n; };
      var tick = function () {
        var diff = end - Date.now();
        if (diff < 0) diff = 0;
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var vals = [pad(d, 3), pad(h), pad(m)];
        nums.forEach(function (el, i) { if (vals[i] !== undefined) el.textContent = vals[i]; });
      };
      tick();
      setInterval(tick, 1000 * 30);
    });
  }

  /* ---------- GATE: ENTER lift (index only) ---------- */
  function initGate() {
    var gate = document.querySelector('[data-kk-gate]');
    if (!gate) return;
    var enter = gate.querySelector('[data-kk-enter]');
    var lift = function () {
      gate.classList.add('is-lifted');
      try { sessionStorage.setItem('kk_entered', '1'); } catch (e) {}
      setTimeout(function () { gate.style.display = 'none'; }, 1300);
    };
    if (enter) enter.addEventListener('click', lift);
    var inEditor = window.Shopify && window.Shopify.designMode;
    try {
      if (!inEditor && sessionStorage.getItem('kk_entered') === '1') {
        gate.style.transition = 'none';
        gate.classList.add('is-lifted');
        gate.style.display = 'none';
      }
    } catch (e) {}
  }

  /* ---------- PRODUCT: 360 turntable ---------- */
  function initTurntable() {
    var scenes = document.querySelectorAll('[data-kk-tt]');
    scenes.forEach(function (scene) {
      var rotor = scene.querySelector('[data-kk-rotor]');
      var deg = scene.parentNode.querySelector('[data-kk-deg]') ||
                document.querySelector('[data-kk-deg]');
      if (!rotor) return;
      var angle = 0, last = 0, dragging = false;
      var apply = function () {
        rotor.style.transform = 'rotateY(' + angle + 'deg)';
        if (deg) deg.textContent = (((Math.round(angle) % 360) + 360) % 360) + '°';
      };
      var down = function (x) { dragging = true; last = x; scene.setAttribute('data-dragging', '1'); };
      var move = function (x) {
        if (!dragging) return;
        angle += (x - last) * 0.6;
        last = x;
        apply();
      };
      var up = function () { dragging = false; scene.removeAttribute('data-dragging'); };

      scene.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
      window.addEventListener('mousemove', function (e) { move(e.clientX); });
      window.addEventListener('mouseup', up);
      scene.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
      scene.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      scene.addEventListener('touchend', up);
      // gentle idle auto-spin until first interaction
      var idle = setInterval(function () {
        if (dragging) { clearInterval(idle); return; }
        angle += 0.25; apply();
      }, 40);
      scene.addEventListener('mousedown', function () { clearInterval(idle); });
      scene.addEventListener('touchstart', function () { clearInterval(idle); });
      apply();
    });
  }

  /* ---------- PRODUCT: size pills -> variant ---------- */
  function initSizes() {
    var forms = document.querySelectorAll('[data-kk-form]');
    forms.forEach(function (form) {
      var pills = form.querySelectorAll('[data-kk-variant]');
      var idInput = form.querySelector('[name="id"]');
      var buy = form.querySelector('[data-kk-buy]');
      var priceEl = form.querySelector('[data-kk-price]');
      var select = function (pill) {
        if (pill.hasAttribute('data-soldout')) return;
        pills.forEach(function (p) { p.classList.remove('is-sel'); });
        pill.classList.add('is-sel');
        if (idInput) idInput.value = pill.getAttribute('data-kk-variant');
        if (buy) buy.removeAttribute('disabled');
        var pr = pill.getAttribute('data-kk-vprice');
        if (priceEl && pr) priceEl.textContent = pr;
      };
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () { select(pill); });
      });
      // preselect first available
      var firstAvail = form.querySelector('[data-kk-variant]:not([data-soldout])');
      if (firstAvail) select(firstAvail);
    });
  }

  /* ---------- PASSWORD: reveal form ---------- */
  function initPassword() {
    var toggle = document.querySelector('[data-kk-pw-toggle]');
    var form = document.querySelector('[data-kk-pw-form]');
    if (!toggle || !form) return;
    var open = function () {
      form.classList.add('is-open');
      toggle.style.display = 'none';
      var input = form.querySelector('input');
      if (input) input.focus();
    };
    toggle.addEventListener('click', open);
    // auto-open if a password error is shown
    if (document.querySelector('.kk-pw__err')) open();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { initCountdowns(); initGate(); initTurntable(); initSizes(); initPassword();});
  // re-init in Shopify theme editor section reloads
  document.addEventListener('shopify:section:load', function () { initCountdowns(); initGate(); initTurntable(); initSizes(); initPassword();});
})();
